/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { change } from 'redux-form'
import { compose } from 'recompose'
import { connect } from 'react-redux'

const fieldName = 'captcha'

interface IState {
  isCaptchaVerified: boolean,
}

export const formWithCaptchaHoc = WrappedComponent => class FormWithCaptcha extends React.Component<any, IState> {
  private captchaRef = null

  public state = {
    isCaptchaVerified: false,
  }

  private onVerifyCaptcha = response => {
    this.setState({
      isCaptchaVerified: !!response,
    })
  }

  private onSubmit = formValues => {
    return this.props.onSubmit(formValues)
      .then(r => {
        this.onResetCaptcha()
        return Promise.resolve(r)
      })
      .catch(e => {
        this.onResetCaptcha()
        throw e
      })
  }

  private setCaptchaRef = r => this.captchaRef = r

  private onResetCaptcha = () => {
    if (!this.captchaRef) {
      return
    }
    this.setState({
      isCaptchaVerified: false,
    })
    this.captchaRef.reset()
    this.props.change(this.props.form, fieldName, false)
  }

  public render () {
    return (
      <WrappedComponent
        {...this.props}
        captchaFieldName={fieldName}
        captchaRef={this.setCaptchaRef}
        isCaptchaVerified={this.state.isCaptchaVerified}
        onVerifyCaptcha={this.onVerifyCaptcha}
        onSubmit={this.onSubmit}
      />
    )
  }
}

export const formWithCaptcha = WrappedComponent => compose(
  connect(
    null,
    {
      change,
    },
  ),
  formWithCaptchaHoc,
)(WrappedComponent)
